/**
 * @internal
 */
export class BatchMark {
	/**@internal */
	updateMark: number = -1;
	/**@internal */
	indexInList: number = -1;
	/**@internal */
	batched: boolean = false;
}

